import React from 'react';
import Grid from '@mui/material/Grid';
import { StyledFooter } from "./footer.style"
import WrapperContainer from '../WrapperContainer/WrapperContainer';
import { Box, Button } from '@mui/material';
import { ArrowUpward } from '@mui/icons-material';
import { useTheme } from 'styled-components';

export interface IFootterProps{
  copyright: string;
  privacyData: [];
  version: string;
  release: string;
  backToTopLabel: string;
  scrollToTop:  () => void,
};

const Footer = (props : IFootterProps) => {
  const theme = useTheme();
  const {copyright, privacyData, version, release, backToTopLabel, scrollToTop} = props;
  const footerLabel = !!version? `${copyright} ${version}`: `${copyright}`;

  return (
    <StyledFooter className="uptime-footer">      
    <WrapperContainer>
      <Grid container>
        <Grid item 
          xs={12} 
          sx={{ 
            marginTop: '24px', 
            display: 'flex', 
            justifyContent: 'flex-end' 
          }}>
          <Box>
            <Button 
              variant='text' 
              startIcon={<ArrowUpward />}
              sx={{
                color: theme.uptimeColors.generalColors.button.hyperlink.enabled,
                fontSize: `${theme.uptimeFontSizes.desktop.fz4}px`,
                fontWeight: 600,
                lineHeight: `${theme.uptimeLineHeights.desktop.lh4}px`,
                fontFamily: `${theme.uptimeFonts.primary}${theme.uptimeFonts.secondary && `,${theme.uptimeFonts.secondary}`}`,
                letterSpacing: 0.4,
                textTransform: 'capitalize',
                '&:hover': {
                  backgroundColor: `${theme.uptimeColors.generalColors.button.hyperlink.enabled}0a`
                }
              }}
              onClick={scrollToTop}
            >
              {backToTopLabel}
            </Button>
          </Box>
        </Grid>
      </Grid>
      <Grid container className="uptime-footer-container">
        <Grid item xs={12} sm={8} md={8} sx={{ textAlign: { xs: 'center', sm: 'unset'}}}>
          <p id="lbl-footer-version">
            {footerLabel} {release}
          </p>
        </Grid>
        <Grid item xs={12} sm={4} md={4} className="uptime-footer-link">
          <ul>
            {privacyData?.map((item : {path: any; title: any;}, index) => (
              <li key={index}>
                  <a href={item.path} target="blank">{item.title}</a>
              </li>
            ))}
          </ul>
        </Grid>
      </Grid>
    </WrapperContainer>
    </StyledFooter>
  );
};


export default Footer;



